import { Row, Col, Button, Space, Modal, Select, Input, InputNumber, message, Table, Tag, Divider, Typography } from 'antd';
import {
    EditFilled,
    PlusOutlined,
    MinusOutlined,
    ReloadOutlined,
    SearchOutlined,
    FileTextOutlined,
    ToolOutlined,
} from "@ant-design/icons";
import React, { useEffect, useRef, useState } from 'react';
import { get_listeCamion } from '../../../api/camion';
import { createEntretien, getEntretien } from '../../../api/entretien';
import { create_maintenance, get_liste_maintenance } from '../../../api/maintenance';
// TODO: adapter ces imports au(x) fichier(s) API réel(s) de ton projet
import Notification from '../../../composants/Notification';
import formatDateFr, { getPermissionsFromToken, hasPermission } from "../../../utils/utils";
import { create_additionnal_commande, create_commande } from '../../../api/commandes';
import { get_ListeAppartenance } from '../../../api/appartenance';
import { get_ListeChauffeur } from '../../../api/chauffeur';
const { Option } = Select
const { TextArea } = Input
const { Text } = Typography


const commonInputStyle = { width: "100%" };

const Entretien = () => {
    const [loadingReload, setLoadingReload] = useState(false);
    const [addModal, setaddmodal] = useState(false)
    const [editModal, seteditModal] = useState(false)
    const [isloading, setisloading] = useState(false)
    const handleReload = () => {
        setLoadingReload(true);
        setTimeout(() => {
            window.location.reload();
        }, 1500);
    };
    const [listeCamion, setlisteCamion] = useState([])
    const [listeEntretien, setlisteEntretien] = useState([])
    const [selectedEntretien, setselectedEntretien] = useState({
        "camion_id": 0,
        "description": null
    })
    const [currentEntretien, setCurrentEntretien] = useState({})
    const [newMaintenance, setnewMaintenance] = useState({
        "nom": "",
        "quantite": 0,
        "prix": 0,
        "description": "Fournisseurs: \n Marque:\n Etat: \n Type de paiement: \nRef facture:  "
    })
    const [listeMAintenanceEntretien, setlisteMAintenanceEntretien] = useState([])

    // ---- Modal "Bon de commande" (BC) ----
    const [bcModal, setBcModal] = useState(false)
    const [listeChauffeur, setlisteChauffeur] = useState([])
    const [selectedCamion, setselectedCamion] = useState([])
    const [lignes, setlignes] = useState([
        { nom: "", reference: "", qte: 1, prix_unitaire: 0 }
    ])
    const [isloadingBC, setisloadingBC] = useState(false)

    // ---- Recherche / filtres sur la table principale ----
    const [searchText, setSearchText] = useState('');
    const [searchedColumn, setSearchedColumn] = useState('');
    const searchInput = useRef(null);

    const canEdit = hasPermission(getPermissionsFromToken(), "ENTRETIEN_EDIT") && parseInt(localStorage.getItem('fonction_id')) === 1;
    const canAdd = hasPermission(getPermissionsFromToken(), "ENTRETIEN_ADD") && parseInt(localStorage.getItem('fonction_id')) === 1;

    const handleSearch = (selectedKeys, confirm, dataIndex) => {
        confirm();
        setSearchText(selectedKeys[0]);
        setSearchedColumn(dataIndex);
    };

    const handleResetSearch = (clearFilters) => {
        clearFilters();
        setSearchText('');
    };

    const getColumnSearchProps = (dataIndex, placeholder) => ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
            <div style={{ padding: 8 }} onKeyDown={(e) => e.stopPropagation()}>
                <Input
                    ref={searchInput}
                    placeholder={placeholder}
                    value={selectedKeys[0]}
                    onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                    onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
                    style={{ marginBottom: 8, display: 'block' }}
                />
                <Space>
                    <Button
                        type="primary"
                        onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
                        icon={<SearchOutlined />}
                        size="small"
                        style={{ width: 90 }}
                    >
                        Chercher
                    </Button>
                    <Button
                        onClick={() => clearFilters && handleResetSearch(clearFilters)}
                        size="small"
                        style={{ width: 90 }}
                    >
                        Réinitialiser
                    </Button>
                </Space>
            </div>
        ),
        filterIcon: (filtered) => (
            <SearchOutlined style={{ color: filtered ? '#1677ff' : undefined }} />
        ),
        onFilter: (value, record) =>
            record[dataIndex]
                ? record[dataIndex].toString().toLowerCase().includes(value.toLowerCase())
                : false,
        onFilterDropdownOpenChange: (visible) => {
            if (visible) {
                setTimeout(() => searchInput.current?.select(), 100);
            }
        },
        render: (text) =>
            searchedColumn === dataIndex ? (
                <span style={{ fontWeight: 600, backgroundColor: '#fffb8f' }}>{text}</span>
            ) : (
                text
            ),
    });

    const columnsEntretien = [
        {
            title: "Id",
            dataIndex: "entretien_id",
            key: "entretien_id",
            width: 140,
            fixed: "left",
           render: (entretien_id) => <Tag color="blue" style={{ fontWeight: 600 }}>{entretien_id}</Tag>,
        },
        {
            title: "Camion",
            dataIndex: "imm",
            key: "imm",
            width: 140,
            fixed: "left",
            sorter: (a, b) => (a.imm || '').localeCompare(b.imm || ''),
            ...getColumnSearchProps("imm", "Rechercher un camion"),
            render: (imm) => <Tag color="blue" style={{ fontWeight: 600 }}>{imm}</Tag>,
        },
        {
            title: "Date",
            dataIndex: "create_at",
            key: "create_at",
            width: 130,
            align: "center",
            sorter: (a, b) => new Date(a.create_at) - new Date(b.create_at),
            defaultSortOrder: "descend",
            render: (date) => formatDateFr(date),
        },
        
        {
            title: "Description",
            dataIndex: "description",
            key: "description",
            ellipsis: true,
            ...getColumnSearchProps("description", "Rechercher dans la description"),
        },
        {
            title: "Actions",
            key: "actions",
            width: 350,
            align: "center",
            fixed: "right",
            render: (_, item) => (
                canEdit ? (
                    <Space>
                        <Button
                            icon={<ToolOutlined />}
                            onClick={() => handleDoMaintenance(item)}
                            style={{
                                backgroundColor: '#ffc107',
                                borderColor: '#ffc107',
                                color: '#212529',
                                fontWeight: 500
                            }}
                        >
                            Maintenance
                        </Button>
                        <Button
                            icon={<FileTextOutlined />}
                            onClick={() => handleOpenBC(item)}
                            style={{
                                backgroundColor: '#17a2b8',
                                borderColor: '#17a2b8',
                                color: '#fff',
                                fontWeight: 500
                            }}
                        >
                            BC
                        </Button>
                    </Space>
                ) : (
                    <span style={{ color: '#bfbfbf' }}>—</span>
                )
            ),
        },
    ];

    const columnsTablePiece = [
        {
            title: "Id",
            dataIndex: "id",
            key: "id",
            align: "center",
        },
        {
            title: "Date",
            dataIndex: "create_at",
            key: "create_at",
            align: "center",
            sorter: (a, b) => new Date(a.create_at) - new Date(b.create_at),
            render: (date) => formatDateFr(date),
        },
        {
            title: "Nom",
            dataIndex: "nom",
            key: "nom",
            align: "center",
        },
        {
            title: "Quantité",
            dataIndex: "qte",
            key: "qte",
            align: "center",
            sorter: (a, b) => a.qte - b.qte,
        },
        {
            title: "Prix unitaire",
            dataIndex: "pu",
            key: "pu",
            align: "center",
            sorter: (a, b) => a.pu - b.pu,
        },
        {
            title: "Description",
            dataIndex: "description",
            key: "description",
            align: "center",
            ellipsis: true,
        },
    ];

    const [showToast, setshowToast] = useState(false)
    const [notif, setnotif] = useState({
        "message": null,
        "info": null
    })


    useEffect(() => {
        fetchListeCamion()
        fetchListeEntretien()
        fetchListeChauffeur()
    }, []);

    const fetchListeCamion = async () => {
        const res = await get_listeCamion()
        if (res.status === "success") {
            setlisteCamion(res.data)
        }
    }

    const fetchListeChauffeur = async () => {
        // TODO: adapter à l'API réelle des chauffeurs
        const res = await get_ListeChauffeur()
        if (res.status === "success") {
            setlisteChauffeur(res.data)
        }
    }

    const fetchListeEntretien = async () => {
        const res = await getEntretien()
        if (res.status === "success") {
            setlisteEntretien(res.data)
        }
    }

    const fetchListeEntretienMaintenance = async (entretien_id) => {
        const res = await get_liste_maintenance(entretien_id)
        if (res.status === "success") {
            setlisteMAintenanceEntretien(res.data)
        }
    }


    const handleAdd = () => {
        setaddmodal(true)
    }

    const handleCloseAdd = () => {
        setaddmodal(false)
    }

    const handleAddEntretien = async () => {
        if (selectedEntretien.camion_id === 0 || selectedEntretien.description === null) {
            message.warning("Veuillez séléctionner un camion et mettre une description !!!!")
        } else {
            setLoadingReload(true)
            const res = await createEntretien(selectedEntretien)
            if (res.status === "success") {
                message.success("Entretien enregistré !!!", 1500)
                setnotif({
                    ...notif,
                    message: "Entretien ajouité avec succès",
                    info: "success"
                })
                setshowToast(true)
                setTimeout(() => {
                    window.location.reload()
                }, 2000);
            } else {
                message.warning("Erreur lors de l'enrgistrement de l'entretien ", 1500)
                setnotif({
                    ...notif,
                    message: "Erreur lors de l'ajout de l'entretien",
                    info: "error"
                })
                setshowToast(true)
                setTimeout(() => {
                    window.location.reload()
                }, 1500);
            }
            setTimeout(() => {
                window.location.reload()
            }, 1500);
        }
    }

    const handleDoMaintenance = async (item) => {
        setCurrentEntretien(item)
        await fetchListeEntretienMaintenance(item.entretien_id)
        seteditModal(true)
    }

    // ---- Ouverture du modal "Bon de commande" depuis le bouton BC ----
    const handleOpenBC = async (item) => {
        setCurrentEntretien(item)
        // Précharge la ligne camion avec le camion concerné par l'entretien
        setselectedCamion([{
            camion_id: item.camion_id,
            chauffeur_id: item.chauffeur_id || null,
            coefficient_charge: "",
            coefficient_vide: "",
            compagnie: "",
            agence: "",
            observation: "",
        }])
        setlignes([{ nom: "", ref: "", qte: 1, prix_unitaire: 0 }])
        setBcModal(true)
    }

    const handleCloseBC = () => {
        setBcModal(false)
    }


    const updateCamionField = (index, field, value) => {
        setselectedCamion(prev => {
            const updated = [...prev]
            updated[index] = { ...updated[index], [field]: value }
            return updated
        })
    }

    const addCamionRow = () => {
        setselectedCamion(prev => ([
            ...prev,
            {
                camion_id: null,
                chauffeur_id: null,
                coefficient_charge: "",
                coefficient_vide: "",
                compagnie: "",
                agence: "",
                observation: "",
            }
        ]))
    }

    const removeCamionRow = (index) => {
        setselectedCamion(prev => prev.filter((_, i) => i !== index))
    }

    const updateLigne = (index, field, value) => {
        setlignes(prev => {
            const updated = [...prev]
            updated[index] = { ...updated[index], [field]: value }
            return updated
        })
    }

    const addLigne = () => {
        setlignes(prev => ([...prev, { nom: "", reference: "", qte: 1, prix_unitaire: 0 }]))
    }

    const removeLigne = (index) => {
        setlignes(prev => prev.filter((_, i) => i !== index))
    }

    const onSubmit = async () => {
        if (!selectedCamion.length || selectedCamion.some(c => !c.camion_id)) {
            message.warning("Veuillez renseigner au moins un camion !!!")
            return
        }
        if (!lignes.length || lignes.some(l => !l.nom || !l.qte || !l.prix_unitaire)) {
            message.warning("Veuillez compléter toutes les lignes de la commande !!!")
            return
        }
        const payload = {
            camions: selectedCamion,
            lignes: lignes,
            total: lignes.reduce((sum, l) => sum + (l.qte * l.prix_unitaire), 0),
            entretien_id: currentEntretien.entretien_id,
        }
        setisloadingBC(true)
        // TODO: adapter à l'API réelle de création de commande
        const res = await create_additionnal_commande(payload)
        if (res.status === "success") {
            message.success("Commande créée avec succès !!!")
            setBcModal(false)
        } else {
            message.warning("Erreur lors de la création de la commande !!!")
        }
        setisloadingBC(false)
    }

    const handleCloseEdit = () => {
        seteditModal(false)
        setselectedEntretien({
            "camion_id": 0,
            "description": null
        })
    }

    const handleAddMaintenance = async () => {
        if (newMaintenance.nom === null || newMaintenance.quantite === 0 || newMaintenance.prix === 0) {
            message.warning("Champ obligatoire vide !!!", 2000)
            setnotif({
                ...notif,
                message: "Champ obligatoire vide !!!",
                info: ""
            })
            setshowToast(true)
            setTimeout(() => {
                setshowToast(false)
            }, 1500);
            setisloading(false)

        } else {
            setisloading(true)
            const res = await create_maintenance(newMaintenance, currentEntretien)
            if (res.status === "success") {
                message.success("Maintenance crée avec success")
                setnotif({
                    ...notif,
                    message: "Maintenance crée avec succès",
                    info: "success"
                })
                setshowToast(true)
                setTimeout(() => {
                    setisloading(false)
                }, 1500);
                setshowToast(false)
            } else {
                message.warning("Maintenance non ajouter !!!")
                setnotif({
                    ...notif,
                    message: "Erreur lors de l'ajout de la maintenance",
                    info: "error"
                })
                setshowToast(true)
                setTimeout(() => {
                    setshowToast(false)
                }, 1500);
                setisloading(false)

            }
            fetchListeEntretienMaintenance(currentEntretien.entretien_id)
            setnewMaintenance({
                "nom": "",
                "quantite": 0,
                "prix": 0,
                "description": null
            })
            setisloading(false)

        }
    }

    const paginationConfig = {
        pageSize: 10,
        position: ["bottomCenter"],
        className: "custom-pagination",
        showTotal: (total, range) => `${range[0]}-${range[1]} sur ${total} entretiens`,
        style: {
            display: "flex",
            justifyContent: "center",
            marginTop: 12,
        },
        itemRender: (page, type, originalElement) => {
            if (type === "page") {
                return (
                    <div
                        style={{
                            borderRadius: "50%",
                            minWidth: 32,
                            height: 32,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            border: "1px solid #d9d9d9",
                        }}
                    >
                        {page}
                    </div>
                );
            }
            return originalElement;
        },
    };

    return (
        <div>
            <Row justify="space-between" align="middle">
                <Col>
                    <h3 style={{ marginBottom: "4px" }}><strong>Entretien</strong></h3>
                </Col>
                <Col>
                    <Space>
                        <Button
                            className='btn btn-success'
                            loading={loadingReload}
                            onClick={handleReload}
                            icon={<ReloadOutlined />}
                        >
                            Actualiser
                        </Button>
                        {
                            canAdd &&
                            <Button
                                type="primary"
                                onClick={handleAdd}
                                icon={<PlusOutlined />}
                            >
                                Ajouter
                            </Button>
                        }
                    </Space>
                </Col>
            </Row>
            <br />

            <Table
                columns={columnsEntretien}
                dataSource={listeEntretien}
                rowKey="entretien_id"
                bordered
                size="middle"
                scroll={{ x: 800, y: '60vh' }}
                pagination={paginationConfig}
                rowClassName={(_, index) => (index % 2 === 0 ? 'row-even' : 'row-odd')}
                style={{
                    borderRadius: 8,
                    overflow: 'hidden',
                    boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
                }}
            />

            <style>{`
                .row-even { background-color: #ffffff; }
                .row-odd { background-color: #fafafa; }
                .ant-table-tbody > tr:hover > td {
                    background-color: #e6f4ff !important;
                    transition: background-color 0.2s ease;
                }
                .ant-table-thead > tr > th {
                    background-color: #f0f5ff !important;
                    font-weight: 600;
                }
            `}</style>

            <Modal
                open={addModal}
                onCancel={handleCloseAdd}
                footer={null}
                title={"Effectuer un entretien"}
            >
                <Row>
                    <Col span={8}>
                        <span>Selectionner le camion</span>
                    </Col>
                    <Col span={16}>
                        <Select
                            size='medium'
                            style={{ width: "100%", textAlign: "center" }}
                            value={selectedEntretien.camion_id !== 0 ? selectedEntretien.camion_id : null}
                            onChange={(value) => {
                                setselectedEntretien({
                                    ...selectedEntretien,
                                    camion_id: value
                                })
                            }}
                            placeholder="test"
                        >
                            {
                                listeCamion && listeCamion.map(item => {
                                    return (
                                        <Option key={item.id} value={item.id}>{item.imm}</Option>
                                    )
                                })
                            }
                        </Select>
                    </Col>
                </Row>
                <br />
                <Row>
                    <Col span={8}>
                        <span>Description</span>
                    </Col>
                    <Col span={16}>
                        <Input.TextArea
                            value={selectedEntretien.description ? selectedEntretien.description : null}
                            onChange={(e) => {
                                setselectedEntretien({
                                    ...selectedEntretien,
                                    description: e.target.value
                                }
                                )
                            }}
                        />
                    </Col>
                </Row>
                <br />
                <Row>
                    <Col span={8}>
                    </Col>
                    <Col span={16} style={{ textAlign: "center" }}>
                        <Button
                            loading={isloading}
                            type='primary'
                            onClick={handleAddEntretien}
                        >
                            Enregistrer
                        </Button>
                    </Col>
                </Row>
            </Modal>

            <Modal
                open={editModal}
                onCancel={handleCloseEdit}
                footer={null}
                title={"Maintenance"}
                style={{
                    top: 5,
                    marginLeft: "22%"
                }}
                width="70%"
            >
                <Row>
                    <Col span={20}>
                        <Row>
                            <Col span={8}>
                                <Row>
                                    <Col span={6} style={{ textAlign: "center" }}>
                                        <span>Pièce</span>
                                    </Col>
                                    <Col span={18}>
                                        <Input
                                            style={{ width: "100%" }}
                                            value={newMaintenance.nom ? newMaintenance.nom : null}
                                            onChange={(e) => {
                                                setnewMaintenance({
                                                    ...newMaintenance,
                                                    "nom": e.target.value
                                                })
                                            }}
                                        />
                                    </Col>
                                </Row>
                            </Col>
                            <Col span={8}>
                                <Row>
                                    <Col span={6} style={{ textAlign: "center" }}>
                                        <span>Quantité</span>
                                    </Col>
                                    <Col span={18}>
                                        <Input
                                            style={{ width: "100%" }}
                                            value={newMaintenance.quantite ? newMaintenance.quantite : null}
                                            onChange={(e) => {
                                                setnewMaintenance({
                                                    ...newMaintenance,
                                                    "quantite": e.target.value
                                                })
                                            }}
                                        />
                                    </Col>
                                </Row>
                            </Col>
                            <Col span={8}>
                                <Row>
                                    <Col span={6} style={{ textAlign: "center" }}>
                                        <span>Prix</span>
                                    </Col>
                                    <Col span={18}>
                                        <Input
                                            style={{ width: "100%" }}
                                            value={newMaintenance.prix ? newMaintenance.prix : null}
                                            onChange={(e) => {
                                                setnewMaintenance({
                                                    ...newMaintenance,
                                                    "prix": e.target.value
                                                })
                                            }}
                                        />
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                        <br />
                        <Row>
                            <Col span={2}>
                                <span>Description</span>
                            </Col>
                            <Col span={22}>
                                <Input.TextArea
                                    style={{ width: "100%", height: "13vh" }}
                                    value={newMaintenance.description ? newMaintenance.description : null}
                                    onChange={(e) => {
                                        setnewMaintenance({
                                            ...newMaintenance,
                                            "description": e.target.value
                                        })
                                    }}
                                />
                            </Col>
                        </Row>
                    </Col>

                    <Col span={4} style={{ padding: 20, textAlign: "center" }}>
                        <Button
                            type='primary'
                            style={{ width: "100%", margin: "0 auto", height: 60 }}
                            onClick={handleAddMaintenance}
                            loading={isloading}
                        >
                            Enregistrer
                        </Button>
                    </Col>
                </Row>
                <br />
                <div style={{ height: 500, overflowY: 'auto' }}>
                    <Table
                        columns={columnsTablePiece}
                        dataSource={listeMAintenanceEntretien}
                        rowKey="id"
                        pagination={{
                            pageSize: 10,
                            position: ["bottomCenter"],
                            className: "custom-pagination",
                            style: {
                                display: "flex",
                                justifyContent: "center",
                                marginTop: 12,
                            },
                            itemRender: (page, type, originalElement) => {
                                if (type === "page") {
                                    return (
                                        <div
                                            style={{
                                                borderRadius: "50%",
                                                minWidth: 32,
                                                height: 32,
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                border: "1px solid #d9d9d9",
                                            }}
                                        >
                                            {page}
                                        </div>
                                    );
                                }
                                return originalElement;
                            },
                        }}
                        scroll={{ y: 400 }}
                        bordered
                    />
                </div>
            </Modal>

            <Modal
                title="Création de la commande"
                open={bcModal}
                onCancel={handleCloseBC}
                width={1000}
                footer={[
                    <Button key="cancel" onClick={handleCloseBC}>
                        Annuler
                    </Button>,
                    <Button key="confirm" type="primary" loading={isloadingBC} onClick={onSubmit}>
                        Créer
                    </Button>,
                ]}
            >
                {/* FACTURES */}
                <div>
                    {selectedCamion && selectedCamion.map((item, index) => (
                        <div key={index} style={{
                            border: "1px solid #e5e5e5",
                            borderRadius: 8,
                            padding: 15,
                            marginBottom: 20,
                            background: "#fafafa"
                        }}>

                            {/* Ligne Camion + Coeffs */}
                            <Row gutter={12} align="middle">
                                <Col span={6}>
                                    <label style={{ fontWeight: 500 }}>Camion</label>
                                    <Select
                                        size="large"
                                        placeholder="Choisir camion"
                                        style={commonInputStyle}
                                        value={item.camion_id}
                                        onChange={(val) => {
                                            const camion = listeCamion.find(c => c.id === val);
                                            updateCamionField(index, "camion_id", val);
                                            if (camion?.chauffeur_id) {
                                                updateCamionField(index, "chauffeur_id", camion.chauffeur_id);
                                            }
                                        }}
                                    >
                                        {listeCamion?.map(c => (
                                            <Option key={c.id} value={c.id}>{c.imm}</Option>
                                        ))}
                                    </Select>
                                </Col>

                                <Col span={6}>
                                    <label style={{ fontWeight: 500 }}>Chauffeur</label>
                                    <Select
                                        size="large"
                                        placeholder="Choisir chauffeur"
                                        style={{ ...commonInputStyle, textAlign: "center" }}
                                        value={item.chauffeur_id}
                                        onChange={(val) => updateCamionField(index, "chauffeur_id", val)}
                                    >
                                        {listeChauffeur?.map(c => (
                                            <Option key={c.id} value={c.id}>{c.prenom}</Option>
                                        ))}
                                    </Select>
                                </Col>

                                <Col span={4} style={{ textAlign: "center" }}>
                                    <span style={{ fontWeight: 500 }}>Coeff chargé</span>
                                    <Input
                                        value={item.coefficient_charge ?? ""}
                                        onChange={(e) => updateCamionField(index, "coefficient_charge", e.target.value)}
                                        style={{ ...commonInputStyle, background: "#fff" }}
                                        placeholder="ex: 0.3"
                                    />
                                </Col>

                                <Col span={4} style={{ textAlign: "center" }}>
                                    <span style={{ fontWeight: 500 }}>Coeff vide</span>
                                    <Input
                                        value={item.coefficient_vide ?? ""}
                                        onChange={(e) => updateCamionField(index, "coefficient_vide", e.target.value)}
                                        style={{ ...commonInputStyle, background: "#fff" }}
                                        placeholder="ex: 0.3"
                                    />
                                </Col>

                                <Col span={4} style={{ textAlign: "center" }}>
                                    {selectedCamion.length > 1 && (
                                        <Button
                                            danger
                                            icon={<MinusOutlined />}
                                            onClick={() => removeCamionRow(index)}
                                            style={{ marginTop: 5 }}
                                        >
                                            Retirer
                                        </Button>
                                    )}
                                </Col>
                            </Row>

                            {/* Ligne compagnie + agence */}
                            <Row gutter={12} style={{ marginTop: 15 }} align="middle">
                                <Col span={12}>
                                    <label style={{ fontWeight: 500 }}>Compagnie</label>
                                    <Input
                                        placeholder="Nom de la compagnie"
                                        value={item.compagnie}
                                        onChange={(e) => updateCamionField(index, "compagnie", e.target.value)}
                                        style={{ marginTop: 5 }}
                                    />
                                </Col>

                                <Col span={12}>
                                    <label style={{ fontWeight: 500 }}>Agence</label>
                                    <Input
                                        placeholder="Agence"
                                        value={item.agence}
                                        onChange={(e) => updateCamionField(index, "agence", e.target.value)}
                                        style={{ marginTop: 5 }}
                                    />
                                </Col>
                            </Row>

                            {/* Observation */}
                            <Row style={{ marginTop: 15 }}>
                                <Col span={24}>
                                    <TextArea
                                        rows={3}
                                        placeholder="Observation"
                                        value={item.observation}
                                        onChange={(e) =>
                                            updateCamionField(index, "observation", e.target.value)
                                        }
                                    />
                                </Col>
                            </Row>

                        </div>
                    ))}
                    <Button
                        type="dashed"
                        icon={<PlusOutlined />}
                        onClick={addCamionRow}
                        style={{ width: "100%" }}
                    >
                        Ajouter un camion
                    </Button>
                </div>
                <Divider />

                {/* HEADER */}
                <Row gutter={8} style={{ marginBottom: 8 }}>
                    <Col span={6}><Text strong>Désignation</Text></Col>
                    <Col span={4}><Text strong>Réf</Text></Col>
                    <Col span={3}><Text strong>Qté</Text></Col>
                    <Col span={5}><Text strong>Prix Unitaire</Text></Col>
                    <Col span={4}><Text strong>Total</Text></Col>
                    <Col span={2}></Col>
                </Row>

                {/* LIGNES */}
                {lignes.map((ligne, index) => {
                    const totalLigne = (ligne.qte || 0) * (ligne.prix_unitaire || 0);

                    return (
                        <Row key={index} gutter={8} align="middle" style={{ marginBottom: 8 }}>
                            {/* NOM */}
                            <Col span={6}>
                                <Input
                                    placeholder="Désignation"
                                    value={ligne.nom}
                                    onChange={(e) =>
                                        updateLigne(index, "nom", e.target.value)
                                    }
                                />
                            </Col>

                            {/* REF */}
                            <Col span={4}>
                                <Input
                                    placeholder="Réf"
                                    value={ligne.reference}
                                    onChange={(e) =>
                                        updateLigne(index, "reference", e.target.value)
                                    }
                                />
                            </Col>

                            {/* QTE */}
                            <Col span={3}>
                                <InputNumber
                                    min={1}
                                    style={{ width: "100%" }}
                                    value={ligne.qte}
                                    onChange={(value) =>
                                        updateLigne(index, "qte", value)
                                    }
                                />
                            </Col>

                            {/* PRIX */}
                            <Col span={5}>
                                <InputNumber
                                    min={0}
                                    style={{ width: "100%" }}
                                    value={ligne.prix_unitaire}
                                    onChange={(value) =>
                                        updateLigne(index, "prix_unitaire", value)
                                    }
                                />
                            </Col>

                            {/* TOTAL */}
                            <Col span={4} style={{ textAlign: "right" }}>
                                <Text>{totalLigne.toLocaleString()} Ar</Text>
                            </Col>

                            {/* ACTIONS */}
                            <Col span={2} style={{ display: "flex", gap: 5 }}>
                                <Button
                                    icon={<PlusOutlined />}
                                    onClick={addLigne}
                                />

                                {lignes.length > 1 && (
                                    <Button
                                        danger
                                        icon={<MinusOutlined />}
                                        onClick={() => removeLigne(index)}
                                    />
                                )}
                            </Col>
                        </Row>
                    );
                })}

                <Divider />

                {/* TOTAL GLOBAL */}
                <Row justify="end">
                    <Col>
                        <Text strong>
                            Total général :{" "}
                            {lignes
                                .reduce((sum, l) => sum + (l.qte * l.prix_unitaire), 0)
                                .toLocaleString()}{" "}
                            Ar
                        </Text>
                    </Col>
                </Row>
            </Modal>

            {
                showToast && <Notification message={notif.message} status={notif.info} />
            }
        </div>
    );
}

export default Entretien;